/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type SnakeMarketsResolvePriceCubeFormat =
  (typeof SnakeMarketsResolvePriceCubeFormat)[keyof typeof SnakeMarketsResolvePriceCubeFormat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SnakeMarketsResolvePriceCubeFormat = {
  DOLLARS: 'DOLLARS',
  CONTRACTS: 'CONTRACTS',
} as const;
